<template>
  <div style="height: 100%;background-color: #ececec;">
    <div class="title fzpsxihjw" style="text-align: center">
      <span style="color: #005db6;font-weight: bold">新闻</span><span style="font-weight: bold">资讯</span>
      <div style="font-size: 1.2rem;color: #7f7f7f;margin-top: 0.5rem">News and Information</div>

    </div>
    <div class="news-row">
      <div class="content">
        <div style="width: 80%;margin-left: 10%;text-align: left" @click="newsDetail(news[0].id)">
          <div class="first">
            <div class="puHuiTi-Medium" style="font-size:3rem;line-height: 2.5rem;margin-top:1rem;font-weight: bold">01</div>
            <div style="font-size: 0.8rem;margin-top: 0.5rem">{{ news[0]?.date }}</div>
          </div>
          <div style="height: 40%;">
            <el-image
                :src="news[0]?.img_url"
                fit="cover"
                style="margin-top: 3rem;height: 15rem;width: 100%"
            />
          </div>
          <div class="news-content-title">{{ news[0]?.title }}</div>
          <div class="puHuiTi-light news-content">{{ news[0]?.content }}</div>
          <div>
            <el-button class="part5-button">查看详情</el-button>
          </div>
        </div>


      </div>
      <div class="content">
        <el-row v-for="(item,index) in news"
                :key="item.title"
                class="right-content"
                :style="index === 0 ? {'padding-top':'10%'}:''"
        >

          <el-col v-if="index!==0" :span="4" class="right-date">
            <div class="puHuiTi-Medium" style="font-size: 3rem;font-weight: bold">0{{ index + 1 }}</div>
            <div style="margin-left: 0.5rem">{{item.date}}</div>
          </el-col>
          <el-col v-if="index!==0" :span="20" @click="newsDetail(item.id)">
            <div class="news-right-content-title">{{ item.title }}</div>
            <div class="puHuiTi-light news-content">{{ item.content }}</div>
          </el-col>
          <el-divider v-if="index!==0" v-show="index+1!==news.length"/>
        </el-row>
      </div>
    </div>
  </div>

</template>

<script setup>

import {ref,onMounted} from "vue";
import {getImagePath, getNewsData} from '@/utils/utils';
import {useRouter} from "vue-router";
const router = useRouter();
const news = ref([

])
const loadJsonData = () => {
  try {
    // 循环 jsonData 的每个键（key），并将它们追加到 menuItems
    let newsData = getNewsData()
    for (let i = 0; i < newsData.length; i++) {
      newsData[i].img_url = getImagePath(newsData[i].img_url,"news")
      news.value.push(newsData[i]);
    }
  } catch (error) {
    console.error("读取 JSON 文件失败:", error);
  }
};


onMounted(() => {
  loadJsonData();
});

function newsDetail(id) {
  router.push({name: 'NewsDetail', params: {id: id}});
}

</script>

<style scoped>
.title {
  font-size: 3rem;
  padding-top: 8rem;
}

.content {
  background-color: white;
  margin-top: 0.8rem;
  text-align: center;
  width: 50%;
  border-radius: 1rem;
}
.news-row >.content:nth-of-type(1){
  margin-right: 3%;
}


.part5-button {
  border-radius: 0.5rem;
  width: 12rem;
  margin-top: 1.2rem;
  background-color: #003795;
  color: white;
  margin-bottom: 3rem;

}

.part5-button:hover {
  background-color: rgb(51.2, 126.4, 204);
  color: white;
}

.news-row {
  margin-top: 2.5rem;
  margin-left: 10%;
  margin-right: 10%;
  display: flex;

}

.news-row > .el-col {
  position: relative;

}

.news-row > .el-col > div {
  height: 100%;
  border-radius: 1.2rem;
}

.news-content-title {
  font-size: 1.5rem;
  margin-top: 1.2rem;
}

.news-content-title + div {
  margin-top: 1rem;
}

.first {
  position: absolute;
  margin-top: 3rem;
  background-color: #003795;
  color: white;
  height: 5rem;
  width: 5rem;
  z-index: 10;
  text-align: center;
}

.right-content {
  width: 80%;
  margin-left: 10%;
  text-align: left
}

.right-date {
  color: #005db6;

}

.news-right-content-title {
  font-size: 1.2rem;
  margin-top: 0.8rem;
}

.news-right-content-title + div {
  margin-top: 0.5rem;
}

.news-content {
  line-height: 1.5; /* 行高，影响实际高度 */
  max-height: 3em; /* 限制显示两行的高度（行高 x 行数） */
  overflow: hidden; /* 隐藏超出部分 */
  display: -webkit-box; /* Flexbox 布局 */
  -webkit-box-orient: vertical; /* 设置为垂直布局 */
  -webkit-line-clamp: 2; /* 限制显示两行 */
  text-overflow: ellipsis; /* 超出部分显示省略号 */

}

</style>